import { AfterViewInit, Component, OnInit } from "@angular/core";
import { Refund } from "src/app/api";

const REFUND_REASONS: Array<{ id: string; descricao: string }> = [
  { id: "extravio",             descricao: "Extravio" },
  { id: "erro_calculo_frete",   descricao: "Erro de cálculo de frete" },
  { id: "erro_pagamento",       descricao: "Erro de pagamento" },
  { id: "erro_dimensionamento", descricao: "Erro de dimensionamento da encomenda" },
  { id: "erro_cobranca_juros",  descricao: "Erro de Cobrança de Juros" },
  { id: "retencao_cliente",     descricao: "Relacionamento de cliente" },
  { id: "cobranca_indevida",    descricao: "Cobrança errônea" },
  { id: "avaria_parcial",       descricao: "Avaria Parcial" },
  { id: "avaria_total",         descricao: "Avaria Total" },
  { id: "devolucao_indevida",   descricao: "Devolução indevida" },
  { id: "atraso",               descricao: "Atraso" },
  { id: "reembolso_indevido",   descricao: "Reembolso indevido" },
];
import { of as observableOf } from "rxjs";
import { catchError, flatMap, startWith, tap } from "rxjs/operators";
import {
  PackageTrackingCodeFilter,
  RecipientNameFilter,
} from "../../dashboard/common-filters";
import {
  ListingSearchFilter,
  ListingSearchType,
} from "../../dashboard/interfaces/listing-search-filter";
import { UiRouterState } from "../../services/ajs-router-state.service";
import { ListingBaseComponent } from "../../dashboard/listing-base.component";
import { StateParamsService } from "../../services/ajs-state-params.service";
import { FinancialApiService as FinancialService } from "./../../services/financial.service";
import { LocalStorageService } from "../../services/localstorage.service";
import { TourService } from "../../tour/tour.service";

@Component({
  selector: "mandae-refund-list",
  templateUrl: "./refund-list.component.html",
  styleUrls: ["./refund-list.component.scss"],
})
export class RefundListComponent
  extends ListingBaseComponent<any>
  implements OnInit, AfterViewInit {
  public filters: ListingSearchFilter[] = [
    PackageTrackingCodeFilter,
    RecipientNameFilter,
    {
      value: "dataOcorrencia",
      viewValue: "Data da ocorrência",
      displayType: ListingSearchType.DateRange,
      placeholder: "Data da ocorrência",
    },
  ];

  public refundReasons: any[] = [];
  public data = [];
  public pages = 0;
  public displayedColumns = [
    "codigo_rastreamento",
    "nome_destinatario",
    "custo_envio",
    "valor_declarado",
    "valor_reembolso",
    "data_ocorrencia",
    "motivo",
    "situacao",
    "fatura",
  ];

  constructor(
    private apiNew: FinancialService,
    private state: UiRouterState,
    private stateParams: StateParamsService,
    private lss: LocalStorageService,
    private tour: TourService
  ) {
    super();
    this.searchParameters = {
      limit: 10,
      offset: 0,
    };
  }

  ngOnInit() {
    super.ngOnInit();

    const user = this.lss.get("user");

    this.getMotivos();

    this.refresh
      .pipe(
        startWith({}),
        tap(() => {
          this.loading = true;
        }),
        flatMap(() => this.buscarReembolsos(user.id)),
        catchError(() => observableOf({ reembolsos: [], total: 0 })),
        tap((data: any) => {
          this.data = data.reembolsos;
          this.pages = Math.ceil(data.total / this.searchParameters.limit);
        }),
        tap(() => {
          this.loading = false;
        })
      )
      .subscribe();
  }

  private async buscarReembolsos(
    idUser: number
  ): Promise<{ reembolsos: any[]; total: number }> {
    const response: any = await this.apiNew.filtrosReembolso(
      idUser,
      Object.assign({}, this.searchParameters, this.filterParameters)
    );

    return typeof response === "string" ? JSON.parse(response) : response;
  }

  ngAfterViewInit() {
    if (this.stateParams.tour) {
      this.startTour();
    }
  }

  getMotivos() {
    this.refundReasons = REFUND_REASONS.map((motivo) => ({
      ...motivo,
      check: true,
    }));
  }

  async aplicarFiltrosMotivos() {
    const status = [];

    this.refundReasons.map((motivo) => {
      if (motivo.check) {
        status.push(motivo.id);
      }

      return;
    });

    this.searchParameters.motivo = status;

    this.aplicarFiltros();
  }

  aplicarFiltros() {
    this.refresh.next();
  }

  isEmptyDatasource() {
    return !this.data || this.data.length === 0;
  }

  gotoTracking(code: string) {
    this.state.go("rastreamento", { numeroRastreio: code });
  }

  getRefundStatusClass(refundStatus: string) {
    let tagStatus = "status-info";
    switch (refundStatus) {
      case "Reembolsado":
        tagStatus = "status-success";
    }

    return "tag " + tagStatus;
  }

  makeAddressFirstLine(element: Refund): string {
    return [
      element.destinatario.cep,
      element.destinatario.cidade,
      element.destinatario.estado,
    ]
      .filter((x) => x)
      .join(" - ");
  }

  makeAddressSecondLine(element: Refund): string {
    return [
      element.destinatario.logradouro,
      element.destinatario.numero,
      element.destinatario.complemento,
    ]
      .filter((x) => x)
      .join(", ");
  }

  public applyStatusFilter(status?: string) {
    if (!status) {
      delete this.searchParameters.tipo;
    } else {
      this.searchParameters.tipo = status;
    }

    this.aplicarFiltros();
  }

  public downloadRelatorio() {
    const user = this.lss.get("user");

    const keys = Object.keys(this.filterParameters);
    const filtro = [];

    for (let i = 0; i < keys.length; i++) {
      const temp = `${keys[i]}=${this.filterParameters[keys[i]]}`;
      filtro.push(temp);
    }

    this.apiNew.downloadRelatorio(user.id, filtro.join("&"), "reembolso");
  }

  private startTour() {
    const steps = this.tour.makeTour([
      {
        title: "Área de Reembolsos",
        text:
          "Acompanhe os reembolsos realizados em sua conta com detalhes do rastreamento e data.",
        attachTarget: () =>
          document.querySelector<HTMLElement>(
            "app-toolbar .mat-tab-label-active"
          ),
        previous: {
          text: "Voltar",
          action: (ev, ref) => {
            ref.close("to_previous_section");
            this.state.go("faturas", { tour: true });
          },
        },
      },
      {
        title: "Reembolsos na fatura",
        text:
          "Veja aqui o número da fatura e a data que foi ou será realizado o reembolso.",
        attachTarget: () =>
          document.querySelector<HTMLElement>("td.mat-column-fatura") ||
          document.querySelector<HTMLElement>("th.mat-column-fatura"),
        next: {
          text: "Ir para Relacionamento",
          action: (ev, ref) => {
            ref.close("to_next_section");
            this.state.go("relacionamento", { tour: true });
          },
        },
      },
    ]);

    this.tour.start(steps).subscribe();
  }
}
